import React from 'react'
import "../CandleDinner/CandleDinner.css"
function CandleDinner() {
    return (
        <div>
            <section className="candle-dinner">
                <div className="candle-dinner-content">
                    <h2 className='CandleDinner-head-text'><label>✨💖</label> Launching Our <span>&nbsp;Candle Light Dinner </span> – From <span>&nbsp;1st September! </span> <label>💖✨</label></h2>
                    <h3 className='CandleDinner-head-sub-text'>Make your evenings unforgettable with a romantic candlelight experience 🌹✨</h3>
                    <div className='CandleDinner-details'>
                        <div className='CandleDinner-offer'>
                            <ul>
                                <h4>Here’s what awaits you:</h4>
                                <li>🥂 2 Welcome Drinks</li>
                                <li>🍰 Red Velvet Cake</li>
                                <li>🍽️ Choice of 5 Premium Platters</li>
                                <li>🥤 2 Fresh Juices</li>
                                <li>💫 Service Charge Included (500৳)</li>
                            </ul>
                        </div>
                        <div className='CandleDinner-platter'>
                            <ul>
                                <h4>Platter Options:</h4>
                                <li>1️⃣ Fiesta – 999৳</li>
                                <li>2️⃣ Staff Fusion Candle Light Platter – 1199৳</li>
                                <li>3️⃣ Continental Cordon Blue Platter – 1269৳</li>
                                <li>4️⃣ Arabian Whole Chicken Khabsa – 1379৳</li>
                                <li>5️⃣ Beef Paper Steak – 1469৳</li>
                            </ul>

                        </div>
                    </div>
                    <h3 className='CandleDinner-head-sub-text'>💡 Whether it’s a romantic date, an anniversary, or just a special night out—this is the perfect dinner under candlelight.</h3>
                    <center>
                        <a href="tel: +8801780126370" target="_blank" rel="noopener noreferrer"><button className='call-now-btn'>📞Call Now</button></a>
                    </center>
                    
                </div>
            </section>
        </div>
    )
}
export default CandleDinner